import AppStorage from '@Services/AppStorage';

export function storeInstitutionRememberMe(rememberMe) {
  AppStorage.instance.setToSessionStorage('institutionRememberMe', rememberMe);
}

export function getInstitutionRememberMe() {
  return AppStorage.instance.getFromSessionStorage('institutionRememberMe');
}

export function removeInstitutionRememberMe() {
  AppStorage.instance.removeFromSessionStorage('institutionRememberMe');
}
